export const PinterestIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='36'
    height='36'
    viewBox='0 0 24 24'
    fill='currentColor'
    {...props}
  >
    <path d='M12 2C6.477 2 2 6.477 2 12c0 4.237 2.633 7.845 6.25 9.356-.021-.823-.004-1.802.203-2.613.208-.797 1.34-5.688 1.34-5.688s-.343-.687-.343-1.701c0-1.595.922-2.788 2.073-2.788 1.01 0 1.492.757 1.492 1.672 0 1.015-.644 2.532-.98 3.935-.282 1.18.59 2.14 1.765 2.14 2.112 0 3.733-2.227 3.733-5.441 0-2.846-2.03-4.912-5.06-4.912-3.415 0-5.385 2.553-5.385 5.183 0 .95.362 1.981.82 2.553.09.11.102.203.076.326-.082.383-.267 1.077-.323 1.282-.07.26-.26.335-.487.23-1.68-.75-2.74-2.583-2.74-4.545 0-3.55 2.583-6.848 7.553-6.848 3.972 0 7.025 2.822 7.025 6.402 0 3.88-2.484 6.94-5.897 6.94-1.152 0-2.24-.587-2.613-1.272l-.768 2.924c-.266 1.015-.99 2.35-1.467 3.127C10.155 21.82 11.066 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z' />
  </svg>
);
